// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__2BD56","title":"AfterFrontImage_title__1ocE_"};